import * as types from "./types";

export const getReasonRequest = (payload) => ({
  type: types.GET_REASON_REQUEST,
  payload,
});

export const getReasonResponse = (payload) => ({
  type: types.GET_REASON_RESPONSE,
  payload,
});

export const getSingleReasonRequest = (payload) => ({
  type: types.GET_SINGLE_REASON_REQUEST,
  payload,
});

export const getSingleReasonResponse = (payload) => ({
  type: types.GET_SINGLE_REASON_RESPONSE,
  payload,
});

export const updateReasonRequest = (payload) => ({
  type: types.UPDATE_REASON_REQUEST,
  payload,
});

export const updateReasonResponse = (payload) => ({
  type: types.UPDATE_REASON_RESPONSE,
  payload,
});
